import React, { useEffect, useState } from "react";
import {
  Paper,
  Grid,
  Box,
  Typography,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Button,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom"; // ใช้ Link แทน useNavigate
import Step1 from "./AuthorizedSignatories";
import Step2 from "./PatientInformation";
import Step3 from "./DiagnosticResults";
import Step4 from "./Certificates";
import Swal from "sweetalert2";

const steps = [
  "ประเภทใบรับรองและบุคคลากรผู้มีสิทธิ์ลงนาม",
  "ข้อมูลผู้เข้ารับการรักษา",
  "ผลการตรวจวินิจฉัยและสรุปความคิดเห็น",
  "ใบรับรอง",
];

const MainFile: React.FC = () => {
  const [activeStep, setActiveStep] = useState(0);
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const [isFormInvalid, setFormInvalid] = useState(true);

  const [formData, setFormData] = useState<any>([]);

  // run when user next or back page
  const handleNext = () => {
    // add condition to check if form is invalid
    if (!isFormInvalid) {
      setActiveStep((prevStep) => prevStep + 1);
      // log formData
      // console.log("formData: ", formData);
      if (formData.length === 0) {
        // check if form data is array
        formData.foreach((item: any) => {
          if (!item.data || !item.key) {
            console.error("not found data: ", item);
            return;
          }
        });
      } else if (
        (!formData.data || !formData.key) &&
        !Array.isArray(formData)
      ) {
        // check if form data and form tag is not empty
        console.error("not found data: ", formData);
        return;
      } else {
        // NOTIHNG TODO
      }
      // check if formData is only one
      if (typeof formData === "object" && !Array.isArray(formData)) {
        sessionStorage.setItem(formData?.key, JSON.stringify(formData.data));
      } else {
        // save data to localStorage
        const saveDataToLocalStorage = async () => {
          formData.map(async (item: any) => {
            // console.log("item: ", item);
            await sessionStorage.setItem(item.key, JSON.stringify(item.data));
          });
        };
        saveDataToLocalStorage();
      }
      // clear useState form
      setFormData([]);
    } else {
      Swal.fire({
        icon: "error",
        title: "กรุณากรอกข้อมูลให้ถูกต้อง",
        showConfirmButton: true,
        confirmButtonText: "ตกลง",
        timer: 1700,
      });
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      return;
    }
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleFormValueChange = (value: boolean, objData?: any) => {
    setFormInvalid(value);
    if (!value && objData?.data) {
      setFormData(objData);
      // console.log("objData condition: ", objData.data);
    } else if (!value && objData?.length) {
      // condition for array of objData
      setFormData(objData);
      // console.log("array of objData condition: ", objData);
    }
  };

  // run once first step has opened. and run again when user next or back page
  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <Step1 onValueChange={handleFormValueChange} />;
      case 1:
        return <Step2 onValueChange={handleFormValueChange} />;
      case 2:
        return <Step3 onValueChange={handleFormValueChange} />;
      case 3:
        return <Step4 />;
      default:
        return null;
    }
  };

  useEffect(() => {
    const getDocMode = sessionStorage.getItem("docMode");
    if (getDocMode) {
      // console.log("currently doc mode: ", getDocMode);
    }
  }, []);

  return (
    <Paper
      elevation={1}
      sx={{ m: 4, height: "auto", borderRadius: 2, position: "relative" }}
    >
      <Grid container sx={{ height: "auto" }}>
        {/* Stepper - ปรับตำแหน่งตามขนาดหน้าจอ */}
        {isLgUp ? (
          <Grid item lg={3} sx={{ backgroundColor: "#EAF2FF" }}>
            {/* แสดง Stepper ทางด้านซ้ายสำหรับหน้าจอใหญ่ขึ้นไป */}
            <Box sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Digital Certificates
              </Typography>
              <Divider sx={{ mb: 2, border: "1px solid #000000" }} />
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </Grid>
        ) : (
          // * Left side content
          <Grid item xs={12}>
            {/* แสดง Stepper ด้านบนสำหรับหน้าจอ xs, sm, md */}
            <Box sx={{ p: 2, backgroundColor: "#EAF2FF" }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Digital Certificates
              </Typography>
              <Divider sx={{ mb: 2, border: "1px solid #000000" }} />
              <Stepper activeStep={activeStep} orientation="horizontal">
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </Grid>
        )}

        {/* Right Side - Content */}
        <Grid item xs={12} lg={9}>
          <Box sx={{ padding: 4 }}>
            {renderStepContent(activeStep)}
            <Divider sx={{ width: "100%", marginTop: 4 }} />
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: 2,
              }}
            >
              {activeStep === 0 ? (
                <Button component={Link} to="/e-digitalcert" color="inherit">
                  ย้อนกลับ
                </Button>
              ) : (
                <Button color="inherit" onClick={handleBack}>
                  ย้อนกลับ
                </Button>
              )}
              <Typography>{`${activeStep + 1}/${steps.length}`}</Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {activeStep === steps.length - 1 ? (
                  <Button
                    component={Link}
                    to="/e-digitalcert"
                    sx={{
                      backgroundColor: "#2F4491",
                      width: "110px",
                      borderRadius: "20px",
                      color: "#ffffff",
                      "&:hover": {
                        backgroundColor: "#2F4491",
                      },
                    }}
                  >
                    เสร็จสิ้น
                  </Button>
                ) : (
                  <Button onClick={handleNext}>ต่อไป</Button>
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default MainFile;
